export default "__VITE_ASSET__S0PJUXTf__"